var EHDI = EHDI || Object.create(null);
var WTE = WTE || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

WTE.GameEngine  = function() 
{
    var TIME_LIMIT = 90000;
    var EASY_DURATION = 30000;
    var SPAWN_DELAY = 400;
    var MAX_ANIMAL_COUNT = 10;//8;//6;
    var MAX_ACTIVE_ANIMAL =6;
    var POMEGRANATE_LIMIT = 3;
    var PAIR_SCORE = 2;
    var TUTORIAL_FRUIT_COUNT = 3;

    EHDI.aka.Container.call(this);

    this.bg;
    var isOver;
    
    this.activeAnimals = [];
    this.vacantCages = [];
    this.alphaMale = null;

    var pauseBtn;

    this.init = function()
    {
        this.bg = new PIXI.extras.TilingSprite(EHDI.Assets.images["bg_eden"], EHDI.GAME.sceneManager.getStageWidth(), EHDI.GAME.sceneManager.getStageHeight());
        this.addChild(this.bg);

        this.layers = [];
        this.cages =[];
        this.generateLayers();

        this.timer =0; 
        this.spawnTimer =  SPAWN_DELAY;

        this.tamer = new WTE.AnimalKeeper();
        this.tamer.init();
        this.spawnCounter = 0;     
        this.fruitCounter = 0;
        
        this.fruits = [];
        EHDI.GAME.constants['fruitDecayTime'] = (SPAWN_DELAY * ((MAX_ANIMAL_COUNT * POMEGRANATE_LIMIT)-POMEGRANATE_LIMIT));

        
        this.scoreEffects = new EHDI.components.ScoreEffectManager();
        this.scoreEffects.init(this);
        
        
        this.pixiPt = new PIXI.Point(this.x, this.y);
    }

    this.generateLayers = function()
    {
        this.gameWidth =EHDI.GAME.sceneManager.getStageWidth();
        this.yMarks = [400, 480, 555, 600];//[350, 450, 525, 600];
        this.cageY = [-50,-50,-50,-30,0,0    ,-25,-25,    -50,-50];
        this.cageX = [400,640, 340,690, 250,825    ,410,650,        94,950    ];
        this.depth =[0.75,0.75,0.875,0.875,1,1  ,1,1,    1,1 ];// [0.5,0.5,0.75,0.75,1,1  ,1,1 ];

        for(var i = 0, l = this.yMarks.length; i< l; i++)
            {
                var layer = new EHDI.aka.Container();
                layer.y = this.yMarks[i];
                this.layers.push(layer);
                this.addChild(layer);
            }

        for(var j = 0; j< MAX_ANIMAL_COUNT; j++)
            {
                var cage = new WTE.Cage();
                cage.init(this.depth[j]);
                cage.x = this.cageX[j];
                cage.y = this.cageY[j];
                
                this.cages.push(cage);
                this.vacantCages.push(j);

            }
        
        var cageCounter =0;
        var placeCage = function(cages, flipSide, scale)
        {
            if(cageCounter >= MAX_ANIMAL_COUNT)
                cageCounter = MAX_ANIMAL_COUNT - 1;

            var cage = cages[cageCounter];
            cage.isFlipped = flipSide;

            cageCounter++;

            return cage;
        }


        var layer0Elem = new EHDI.aka.Sprite(EHDI.Assets.images['eden_prop6']);
            layer0Elem.x = (this.gameWidth - layer0Elem.width) * 0.5;
            layer0Elem.y = layer0Elem.height * -1;

        this.layers[1].addChild(placeCage(this.cages));
        this.layers[1].addChild(placeCage(this.cages, true));
        this.layers[1].addChild(layer0Elem);

        
        this.layer1elem0 = new EHDI.aka.Sprite(EHDI.Assets.images['eden_prop3']);
        this.layer1elem0.x = -52;        
        this.layer1elem0.y = (this.layer1elem0.height * -1);

        this.layer1elem1 = new EHDI.aka.Sprite(EHDI.Assets.images['eden_prop4']);
        this.layer1elem1.x = 180;        
        this.layer1elem1.y = (this.layer1elem1.height * -1) - 20;
        
        this.layer1elem2 = new EHDI.aka.Sprite(EHDI.Assets.images['eden_prop5']);
        this.layer1elem2.x = 550;        
        this.layer1elem2.y = (this.layer1elem2.height * -1) + 20;
            
        this.layer1elem3 = new EHDI.aka.Sprite(EHDI.Assets.images['eden_prop3']);
        this.layer1elem3.x = 724;        
        this.layer1elem3.y = (this.layer1elem3.height * -1) +10;

            
        this.layers[2].addChild(placeCage(this.cages));
        this.layers[2].addChild(this.layer1elem1);
        this.layers[2].addChild(this.layer1elem0);
        this.layers[2].addChild(placeCage(this.cages, true));
        this.layers[2].addChild(this.layer1elem3);
        this.layers[2].addChild(this.layer1elem2);

        

        
        this.layer2elem0 = new EHDI.aka.Sprite(EHDI.Assets.images['eden_prop1']);
        this.layer2elem0.x = -150;        
        this.layer2elem0.y = (this.layer2elem0.height * -1) + 95;

        this.layer2elem1 = new EHDI.aka.Sprite(EHDI.Assets.images['eden_prop1']);
        this.layer2elem1.x = 734;        
        this.layer2elem1.y = (this.layer2elem1.height * -1) + 90;
        
        this.layer2elem2 = new EHDI.aka.Sprite(EHDI.Assets.images['eden_prop2']);
        this.layer2elem2.x = 369;        
        this.layer2elem2.y = (this.layer2elem2.height * -1);


        this.layers[3].addChild(placeCage(this.cages));
        this.layers[3].addChild(this.layer2elem0);
        this.layers[3].addChild(placeCage(this.cages, true));
        this.layers[3].addChild(this.layer2elem1);
        this.layers[3].addChild(this.layer2elem2);

        this.layers[0].addChild(placeCage(this.cages));
        this.layers[0].addChild(placeCage(this.cages, true));

        
        this.layers[3].addChild(placeCage(this.cages));
        this.layers[3].addChild(placeCage(this.cages, true));

        this.fruitBasket = new EHDI.aka.Container();
        this.fruitBasket.y = -370;
        this.layers[1].addChild(this.fruitBasket);


        
        // var testRect = new PIXI.Graphics();
        // testRect.beginFill(0xFF0000);
        // testRect.drawRect(750,0, 250, 75);
        // testRect.endFill();
        // this.fruitBasket.addChild(testRect);

        
        this.fruitScoreEffects = new EHDI.components.ScoreEffectManager();
        this.fruitScoreEffects.init( this.fruitBasket);

    }

    this.gameStart = function()
    {
        scoreHolder = EHDI.scene.GameScene.scoreHolder;
        pauseBtn =EHDI.GAME.pauseButton;

        
        isOver = false;

        this.bindedLoop = gameUpdate.bind(this);
        EHDI.GAME.updateManager.addFrameListener(this.bindedLoop);
    }

    gameUpdate= function(delta)
    {
        if(pauseBtn.isPaused)
        {             
            return;
        }
        this.timer += delta;
        if((this.timer >=  TIME_LIMIT) || (isOver))
        {
            this.gameOver();
            return;
        }
        dragonBones.WorldClock.clock.advanceTime(delta * 0.001);
        this.spawnTimer -= delta;
        if(this.spawnTimer<= 0)
            this.spawnAnimals();

            if(this.fruits.length > 0)
            {
                var pickedFruits = [];
                for(var i = 0, l = this.fruits.length; i<l; i++)
                {
                    var fruit =this.fruits[i];
                    fruit.update(delta);

                    if((fruit.isPicked) || (fruit.fallen))
                    {
                        pickedFruits.push(fruit);
                        this.fruitBasket.removeChild(fruit);
                    }
                }
                    
                POOLS.fruitPool.returnBatch(this.fruits, pickedFruits);

            }

            if(this.activeAnimals.length > 0)
            {
                var escapee = [];
                for(var i = 0, l = this.activeAnimals.length; i<l; i++)
                {
                    var currentAnimal = this.activeAnimals[i];
                    if(currentAnimal.update(delta))
                    {
                        if((currentAnimal.isChosen) && (currentAnimal != this.alphaMale))
                        {
                            if(this.alphaMale == null)
                            {
                                this.alphaMale = currentAnimal;
                                this.alphaMale.setGlow();
                                this.alphaMale.makeSound();
                            }
                            else
                            {
                                var isPair =checkPair(this.alphaMale, currentAnimal);
                                if(isPair)
                                {
                                    var scoreLocCurrent =currentAnimal.toGlobal(this.pixiPt);
                                        this.scoreEffects.popScore(this.cages[currentAnimal.cageNumber].x, scoreLocCurrent.y, 1);
                                    var scoreLocAlpha =this.alphaMale.toGlobal(this.pixiPt);
                                        this.scoreEffects.popScore(this.cages[this.alphaMale.cageNumber].x, scoreLocCurrent.y, 1);

                                    EHDI.scene.GameScene.scoreHolder.addScore(PAIR_SCORE);                                                   
                                    EHDI.GAME.soundManager.playSFX("animal_collect");
                                }
                                else
                                {
                                    this.adjustTime(-2);                                                    
                                    EHDI.GAME.soundManager.playSFX("score_points"); //error sound
                                }

                                currentAnimal.match(isPair);
                                this.alphaMale.match(isPair);

                                this.alphaMale = null;
                            }

                        }
                    }
                    if(currentAnimal.isToDisappear)
                    {
                        if(currentAnimal == this.alphaMale)
                            this.alphaMale = null;

                        this.releaseAnimal(currentAnimal, currentAnimal.isMatched);
                        escapee.push(currentAnimal);
                    }

                    currentAnimal = null;
                }
                POOLS.animPool.returnBatch(this.activeAnimals, escapee);
            }

        this.scoreEffects.update(delta);   
        this.fruitScoreEffects.update(delta);   

    }

    this.adjustTime = function(amount)
    {
        EHDI.scene.GameScene.timer.addTime(amount);
        this.timer -= (amount * 1000);

    }

    this.gameOver = function()
    {
        if(isOver)
            return;

        EHDI.DBoneFactory.enableClock = false;
        isOver = true;                                            
        EHDI.GAME.soundManager.playSFX("success");

        EHDI.GAME.pauseButton.endGame();
        if ( !EHDI.GAME.constants.gameEndFunction ) {
            EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp(getStarRating(), EHDI.scene.GameScene.scoreHolder.getScore()), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
        }
        else EHDI.GAME.constants.gameEndFunction();
        this.removeGameLoop();

       /*  var score = EHDI.scene.GameScene.scoreHolder.getScore();
        if(score > EHDI.GAME.saveData.highScore) {
            EHDI.GAME.saveData.highScore = score;
            EHDI.sthis.bgame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
                console.log("data saved.");
            });
        }
        EHDI.sthis.bgame.end(score); */
    }

    this.removeGameLoop = function()
    {
        EHDI.GAME.updateManager.removeFrameListener(this.bindedLoop);
    }

    checkPair = function(animal1, animal2)
    {
        return (animal1.type == animal2.type);
    }

    getCageCandidates = function(vacant, valid)
    {
        var candidates =[];
        for(var i = 0, l = valid.length; i<l; i++)
            {
                if(vacant.indexOf(valid[i]) != -1)
                    candidates.push(valid[i]);
            }
        return candidates;
    }

    var timeFactorConverter = 1500/TIME_LIMIT;
    this.spawnAnimals = function()
    {
      
        if((this.activeAnimals.length >= MAX_ACTIVE_ANIMAL) || (this.vacantCages.length <= 0))
            return;

        this.spawnTimer =  SPAWN_DELAY;

        var timeFactor = this.timer * timeFactorConverter;
        var animal;
        var cageCandidates;
        var easySpawn  = (this.timer <= EASY_DURATION);

        do
        {
            animal= POOLS.animPool.takeFromPool();
            animal.init(this.tamer.releaseAnimal(), timeFactor, easySpawn);
            cageCandidates = getCageCandidates(this.vacantCages, animal.validCage);

            if(cageCandidates.length < 1)
                {
                    this.tamer.returnAnimal(animal.type, false);
                    POOLS.animPool.returnBatch(null, [animal]);
                }
        }while(cageCandidates.length < 1);

        var cageIndex= UTILS.arrayUtils.getRandom(cageCandidates, true);

        this.cages[cageIndex].addAnimal(animal);
        /*
        if(animal.classification == "bush")
        {
            console.log(this.cages[cageIndex].x, this.cages[cageIndex].y)
        }*/

        UTILS.arrayUtils.removeFromArray(this.vacantCages, [cageIndex]);
        animal.cageNumber = cageIndex;

        animal.appear();
        this.activeAnimals.push(animal);

        this.spawnCounter++;
        if(this.spawnCounter >= 6)
            {
                this.spawnCounter = 0;
                this.growFruit();
            }
    }

    this.releaseAnimal = function (animal, toRoster)
    {        
        this.tamer.returnAnimal(animal.type, toRoster);    
        this.cages[animal.cageNumber].releaseAnimal();
        this.vacantCages.push(animal.cageNumber);

    }

    var fruitXSpawn = [50,100, 150, 200, 250, 750, 800, 850, 900, 950, 1000];
    var basketHeight= 75;
    this.growFruit = function()
    {
        
        // var basketWidth= [200];

        var fruit = POOLS.fruitPool.takeFromPool();
        fruit.init((this.fruitCounter < TUTORIAL_FRUIT_COUNT));
        do
        {
            fruit.x = fruitXSpawn[Math.floor(Math.random() * fruitXSpawn.length)];
        }while(this.checkFruitX(fruit.x));
        
        // fruit.x = fruitXSpawn[Math.floor(Math.random() * fruitXSpawn.length)];

        fruit.y = Math.random() * basketHeight;
        this.fruitBasket.addChild(fruit);
        this.fruits.push(fruit);
        
        this.fruitCounter++;

    }

    this.checkFruitX = function(xTemp)
    {
        if((this.fruits == null) || (this.fruits.length <1))
            return false;

        for(var i = 0, l = this.fruits.length; i<l; i++)
            {
                if(xTemp == this.fruits[i].x)
                    return true;
            }

        return false;
    }

    getStarRating = function()
    {
        var rating = Math.floor(EHDI.scene.GameScene.scoreHolder.getScore() / 25);

        if(rating > 3)
            rating =3;
        
        return rating;
    }

    this.killProps = function()
    {
        for(let i = 0; i< this.depth.length; i++)
        {
            delete this.depth.pop();
        }

        for(let i = 0; i< this.cageX.length; i++)
        {
            delete this.cageX.pop();
        }

        for(let i = 0; i< this.cageY.length; i++)
        {
            delete this.cageY.pop();
        }

        for(let i = 0; i< this.yMarks.length; i++)
        {
            delete this.yMarks.pop();
        }

        delete this.gameWidth;
    }

    this.killGraphics = function()
    {
        if(this.fruitScoreEffects != null)
        {
            this.fruitScoreEffects.dispose();
        }
        delete this.scoreEffects;

        if(this.fruitBasket != null)
        {
            this.layers[1].removeChild(this.fruitBasket);
            this.fruitBasket.destroy({children: true});
        }
        delete this.fruitBasket;

        if(this.layer2elem2 != null)
        {
            this.layers[3].removeChild(this.layer2elem2);
            this.layer2elem2.destroy({children: true});
        }
        delete this.layer2elem2;

        if(this.layer2elem1 != null)
        {
            this.layers[3].removeChild(this.layer2elem1);
            this.layer2elem1.destroy({children: true});
        }
        delete this.layer2elem1;

        if(this.layer2elem0 != null)
        {
            this.layers[3].removeChild(this.layer2elem0);
            this.layer2elem0.destroy({children: true});
        }
        delete this.layer2elem0;

        if(this.layer1elem3 != null)
        {
            this.layers[2].removeChild(this.layer1elem3);
            this.layer1elem3.destroy({children: true});
        }
        delete this.layer1elem3;

        if(this.layer1elem2 != null)
        {
            this.layers[2].removeChild(this.layer1elem2);
            this.layer1elem2.destroy({children: true});
        }
        delete this.layer1elem2;

        if(this.layer1elem1 != null)
        {
            this.layers[2].removeChild(this.layer1elem1);
            this.layer1elem1.destroy({children: true});
        }
        delete this.layer1elem1;

        if(this.layer1Elem0 != null)
        {
            this.layers[2].removeChild(this.layer1Elem0);
            this.layer1Elem0.destroy({children: true});
        }
        delete this.layer1Elem0;

        if(this.cages != null)
        {
            for(let i = 0; i < this.cages.length; i++)
            {
                let cage = this.cages.pop();
                this.layers[0].removeChild(cage);
                this.layers[1].removeChild(cage);
                this.layers[2].removeChild(cage);
                this.layers[3].removeChild(cage);
                cage.destroy({children: true});
                cage = null;
            }
            delete this.cages;
        }

        if(this.layers != null)
        {
            for(let i = 0; i < this.layers.length; i++)
            {
                let layer = this.layers.pop();
                layer.destroy({children: true});
                layer = null;
            }
            delete this.layers;
        }

        delete this.pixiPt;
        
        if(this.scoreEffects != null)
        {
            this.scoreEffects.dispose();
        }
        delete this.scoreEffects;

        if(this.fruits != null)
        {
            for(let i = 0; i < this.fruits.length; i++)
            {
                let fruit = this.fruits.pop();
                fruit.dispose();
                fruit  = null;
            }
        }
        delete this.fruits;

        if(this.tamer != null)
        {
            this.tamer.dispose();
        }
        delete this.tamer;

        if(this.bg != null)
        {
            this.removeChild(this.bg);
            this.bg.destroy({children: true});
        }
        delete this.bg;
    }

    this.killListeners = function()
    {
        EHDI.GAME.updateManager.removeFrameListener(this.bindedLoop);
    }

}
WTE.GameEngine.prototype = Object.create(EHDI.aka.Container.prototype);

POOLS.animPool = new Pool(WTE.Animal, 5);
POOLS.fruitPool = new Pool(WTE.Fruit, 2); 